import { ChallengeGroupModelDto } from '@treasury/api/bo';
import { DomainEntity } from '../../../../shared';

export class AuthenticationProfile extends DomainEntity<ChallengeGroupModelDto> {
    public static from(dto: ChallengeGroupModelDto): AuthenticationProfile {
        return new AuthenticationProfile(dto);
    }

    public createDefault(): this {
        throw new Error('createDefault not implemented');
    }

    public get id(): number {
        return this.dto.id;
    }

    public get name(): string {
        return this.dto.name ?? '';
    }

    public get description(): string {
        return this.dto.description ?? '';
    }

    public get isDefault(): boolean {
        return this.dto.isDefault;
    }
}
